/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import 'container/pictograms/pictograms.css'
import Col from 'component/utils/Col'
import ContentHeader from 'component/utils/ContentHeader'
import FilterForm from 'component/stockTransferApprovers/StockTransferApproversFilterForm'
import UseConsumeModalNew from 'component/useConsume/UseConsumeModalNew'
import UseConsumeModalErrorNew from 'component/useConsume/UseConsumeErrorModalNew'
import Table from 'component/stockTransferApprovers/StockTransferApproversTable'
import Row from 'component/utils/Row'
import NewPagination from 'component/pagination/newPagination'
import SizeSelect, {components} from 'react-select'
import DropdownArrow from 'component/svgComponents/dropdownArrow'
import { colourStyles } from 'utils/selectStyle'
import data from 'container/pictograms/mock'
import * as stockTransferApproversActions from 'action/stockTransferApprovers'

import { isEqual } from 'lodash'
import RemoveModal from 'component/stockTransferApprovers/RemoveModal'
import NewApproveModal from 'component/stockTransferApprovers/NewApproveModal'
import MultiSelector from 'component/stockTransferApprovers/MultiSelector'


const DEFAULT_PAGINATION = {
  hasPagination: true,
  page: 0,
  size: 10,
}

const DEFAULT_INITIAL_VALUES = {
  order: 'dsMission',
  orderDirection: "ASC",
 
  page: 0,
  size: 10,
  status: 2
  
}

const EXTRA_SMALL_SCREEN = 768

const StockTransferApprovers = ({
  auth: {
    user: { dsToken },
  },
  translate,
  list,
  preserve,
  edit,
  change,
  options,
  deletePermissions,
  resetSave,
  auth,
  fetchStockTransferApprovers,
  fetchMissions
}) => {
  const [emptyFilter, setEmptyFilter] = useState(true)
  const [openDeleteModal, setOpenDeleteModal] = useState({show: false, selected: null})
  const [successModalText, setSuccessModalText] = useState("A permissão foi cadastrada com sucesso!")
  const [successModalDeleteText, setSuccessModalDeleteText] = useState()
  const [openSuccessModal, setOpenSuccessModal] = useState(false)
  const [openEditSuccessDeleteModal, setopenEditSuccessDeleteModal] = useState(false)
  const [openErrorModal, setOpenErrorModal] = useState(false)
  const [optionSize, setOptionSize] = useState(10)

  const [cdMissionList, setCdMissionList] = useState([])
  const [openAddModal,setOpenAddModal] = useState(false)

  const headerRef = useRef(null)
  const filterRef = useRef(null)
  const [attributeAlreadyExists, setAttributeAlreadyExists] = useState(false)
  const tableRef = useRef(null)

  const [filters, setFilters] = useState()
  const [pagination, setPagination] = useState(DEFAULT_PAGINATION)
  const [sideFilterElement, setSideFilterElement] = useState(null)
  const [sideFilterVisible, setSideFilterVisible] = useState(false)
  const [sideFilterWidth, setSideFilterWidth] = useState(0)
  const [topMargin, setTopMargin] = useState(0)
  const [errorDetails,setErrorDetails] = useState("")
  const [missionListSelected, setMissionListSelected] = useState([])
  const [actionMode, setActionMode] = useState(false)

  const [order,setOrder] = useState({order: 'dsMission', orderDirection: 'ASC'})

  // Did mount
  useEffect(() => {
    const fetchData = async () => {
      try {
        const param = {
          ...DEFAULT_INITIAL_VALUES,
          ...DEFAULT_PAGINATION
        };
        setFilters(DEFAULT_INITIAL_VALUES);
  
        await fetchMissions(auth.user.dsToken);
  
        fetchStockTransferApprovers(auth.user.dsToken, param);
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
      }
    };
  
    fetchData();
  
    return () => {
      resetSave();
    };
  }, []);
  
  // When pagination changes
  useEffect(() => {
    if(!filters) return
    const param = {
      ...filters,
      ...pagination,
      ...order,
      page: pagination.page
    }
    
    handleAttributes(param)
  }, [pagination])


  const handleResize = () => {
    const header = headerRef.current

    if (header && window.innerWidth > EXTRA_SMALL_SCREEN) {
      const headerClientHeight = header.clientHeight

      const filter = filterRef.current

      const topHeight = headerClientHeight + filter.clientHeight

      let newSideFilterWidth = sideFilterWidth

      filter.style.top = `${headerClientHeight}px`

      if (sideFilterVisible && sideFilterElement)
        newSideFilterWidth = sideFilterElement.clientWidth

      if (topMargin !== topHeight || sideFilterWidth !== newSideFilterWidth) {
        setSideFilterWidth(newSideFilterWidth)

        setTopMargin(topHeight)
      }
    }
  }

  const handleAttributes = (param) => {
    const query = {...param}
    fetchStockTransferApprovers(dsToken, query)
   
  }

  useEffect(() => { 
    if(edit.error &&  edit.error.cdStatus === 409) {
      setAttributeAlreadyExists(true)
    }
  }, [edit])
  

  useEffect(() => {

    if (change.error) {
    
      if (change.error.cdStatus === 409) {
        setAttributeAlreadyExists(true);
        
      } else {
        const errorMessage = change.error.data || "Erro inesperado";
        setErrorDetails(errorMessage);
        setOpenErrorModal(true);
      }
    }
  }, [change]);

  const setValues = (values, isSearch = false) => {
    let updatedFilters = { ...filters, page: 0, o: Math.random() };

    if (isSearch && values) {
      setEmptyFilter(false);
      updatedFilters = { ...updatedFilters, dsMission: values };
    } else if (isSearch && !values) {
      delete updatedFilters.dsMission;
      setEmptyFilter(true);
    } else {
      updatedFilters = { ...updatedFilters, ...values };
    }
  
    setFilters(updatedFilters);
  
    fetchStockTransferApprovers(auth.user.dsToken, updatedFilters);
  }

  const renderRemoveModal = () => {
    if (!openDeleteModal.show) return;
  
    return (
      <RemoveModal
        action={handleDelete}
        closeModal={() => setOpenDeleteModal({ show: false, selected: null })}
        attribute={openDeleteModal.selected}
        translate={translate}
      />
    );
  };
  

  const callBackSave = () => {
    setOpenAddModal(false)
    setOpenSuccessModal(true)   
  }

  const callBackDelete = () => {
    setOpenDeleteModal({show: false, selected: null})
    setopenEditSuccessDeleteModal(true)
    setMissionListSelected([])
    setCdMissionList([])
    fetchMissions(auth.user.dsToken)
  }

  const handleDelete = () => {
    if(openDeleteModal.selected.length <= 1 || !Array.isArray(openDeleteModal.selected)) {
      setSuccessModalDeleteText("A permissão foi excluída com sucesso!")
    } else {
      setSuccessModalDeleteText("As permissões foram excluídas com sucesso!")
    }

    const params = {
      dsMission: Array.isArray(openDeleteModal.selected )  
      ? openDeleteModal.selected.map(mission => mission.id) 
      : openDeleteModal.selected.id
    }
    
    deletePermissions(auth.user.dsToken,params, callBackDelete)
    
  }

  const renderNewPagination = () => {
    const PAGINATION_OPTIONS = [
      { label: '5', value: 5 },
      { label: '10', value: 10 },
      { label: '20', value: 20 },
      { label: '30', value: 30 },
      { label: '40', value: 40 },
    ]

    const countItems = () => {

      if(list.pages.page + 1 === 1) return 1

      return (((list.pages.page + 1) - 1) * optionSize) + 1
    }

    const DropdownIndicator = props => (
      <components.DropdownIndicator {...props}>
        <DropdownArrow />
      </components.DropdownIndicator>
    )

    if (!list?.resultList || list.resultList.length === 0) return;

    return (
      <Row className="new-relatory-row stock-transfer-pagination" >
        <Col className="align-center margin-bottom ">

          <NewPagination
          navClass='pagination new-relatory'
          count={list.pages.totalCount}
          current={list.pages.page + 1}
          getPage={(page) => setPagination({ ...pagination, size: optionSize,  page: page - 1 })}
          pages={list.pages.pageCount}
          />

        <div  className='datasheet-manager-pagination-size-selector show-pages-new-relatory'>
          <Col className="show-per-page-text" xs={7}>{translate('pagination.size.selector')}</Col>
          <Col xs={4}>
            <SizeSelect
              components={{DropdownIndicator}}
              isSearchable={false}
              styles={colourStyles}
              classNamePrefix='react-select'
              onChange={(option) => {
                setOptionSize(option.value)
                setPagination({...pagination, page: 0, size: option.value})
              }}
              options={PAGINATION_OPTIONS}
              value={PAGINATION_OPTIONS.find((i) => i.value === optionSize)}
              menuPlacement='top'
            />
          </Col>
        </div>


        <div style={{float: 'left'}} className='datasheet-manager-pagination-size-selector show-items-new-relatory'>
          <Col >
            {`
              ${translate('pagination.size.show')}
              ${countItems()} - ${(list.pages.page + 1) * optionSize > list.pages.totalCount ? list.pages.totalCount : (list.pages.page + 1) * optionSize }
              ${translate("pagination.size.of")}
              ${list.pages.totalCount}
              ${translate("pagination.size.items")}
            `}
          </Col>

        </div>

        </Col>
      </Row>
    )
  }

  useEffect(() => {
    if(cdMissionList.length === 0) {
      setMissionListSelected([])
      return
    }
    const selecteds = [...data].filter(mission => cdMissionList.includes(mission.id))
    
    const cloneSelecteds = [...missionListSelected]
    selecteds.forEach((element) => {
      const findMission = missionListSelected.filter(mission => element.id === mission.id).length > 0
      if(!findMission) cloneSelecteds.push(element)
    })
    setMissionListSelected(cloneSelecteds)

  },[cdMissionList])

  const removeSelected = (cdMission) => {
    const hasSelected = data.filter(mission => mission.id === cdMission).length > 0
    if(hasSelected) {
      const newSelecteds = [...missionListSelected].filter(mission => mission.id !== cdMission)

      setMissionListSelected(newSelecteds)
    }
  }

  const renderAddModal = () => {
    
    if(!openAddModal) return
    return (
      <NewApproveModal
        options={options}
        closeModal={() => setOpenAddModal(false)}
        submit={beforeSave}
        user={auth.user}
        attributeAlreadyExists={attributeAlreadyExists}
        handleAttributeAlreadyExists={(value ) => setAttributeAlreadyExists(value)}
        translate={translate}
      />
    )
  }

  const renderErrorModal = () => {
    if(!openErrorModal) return

    return (
      <UseConsumeModalErrorNew
        onConfirm={() => setOpenErrorModal(false)}
        text={"Houve um erro ao cadastrar o permissão"}
        title={'Ops!'}
        details={errorDetails || "Erro desconhecido"}
        okButton={'Tentar novamente'}
      />
    )
  }

  const renderAlreadyMissionModal = () => {
    if(!attributeAlreadyExists) return

    return (
      <UseConsumeModalErrorNew
        onConfirm={() => setAttributeAlreadyExists(false)}
        text={"Permissão já cadastrada"}
        title={'Ops!'}
        okButton={'Tentar novamente'}
      />
    )
  }

  const renderSuccessDeleteModal = () => {
    if (!openEditSuccessDeleteModal) return null;
 
    return (
      <UseConsumeModalNew
        onConfirm={() => { 
          setopenEditSuccessDeleteModal(false)
          setTimeout(() => {
            const params = {
              ...pagination,
              ...filters,
              page: pagination.page,
              size: pagination.size, 
              ...order
            }
            handleAttributes(params)

          }, [100])
        }
        }
        text={successModalDeleteText}
        title={translate('missionMenu.successModal.title.6')}
        okButton={"OK"}
      />
    )
  }

  const renderSuccessModal = () => {
    if (!openSuccessModal) return

    return (
      <UseConsumeModalNew
        onConfirm={() => { 
          setOpenSuccessModal(false)
          setTimeout(() => {
            const params = {
              ...pagination,
              ...filters,
              page: 0,
              size: pagination.size, 
              ...order
            }
            handleAttributes(params)

          }, [100])
        }
        }
        text={successModalText}
        title={translate('missionMenu.successModal.title.6')}
        okButton={"OK"}
      />
    )
  }

  const beforeSave = async (formData) => {
    if(formData.dsMission.length > 1) {
      setSuccessModalText("As permissões foram cadastradas com sucesso!")
    }
    else {
      setSuccessModalText("A permissão foi cadastrada com sucesso!")
    }
    formData.cdLdap = auth.user.username
    formData.dsLdap = auth.user.fullName
    
    preserve(auth.user.dsToken, formData, callBackSave)
  }

  useEffect(() => {
    if(cdMissionList.length > 0 && !actionMode) {
      setActionMode(true)
    }

  }, [cdMissionList])

  const handleOrder = (order,orderDirection) => {
    const param = {
      ...filters,
      ...pagination,
      order,
      orderDirection
    }

    setOrder({order, orderDirection})

    handleAttributes(param)
  }

  const inActionMode = cdMissionList.length > 0

  return (
    <div className='stock-adjustment stock-transfer-approvers'>
      <div ref={headerRef} className='stock-adjustment-header'>
        <ContentHeader>{'Aprovadores de transferência de estoque'}</ContentHeader>
      </div>

      <div ref={filterRef} className='padding-bottom header-mission-block'>
        <div style={{display: inActionMode ? 'none' : ''}}>
          <FilterForm  
            visible={!actionMode} 
            submit={setValues} 
            translate={translate} />
        </div>

        <MultiSelector
          attributesSelected={cdMissionList}
          cdMissionListLength={cdMissionList.length}
          handleSideFilterMenuCollapseChange={setSideFilterVisible}
          setCdMissionList={setCdMissionList}
          setRemoveModal={(attr) => setOpenDeleteModal({show: true, selected: attr})}
          sideFilterVisible={sideFilterVisible}
          translate={translate}
        />

        <div>
          <button 
          style={{display: inActionMode ? 'none' : '', marginRight: '24px', background: "#41A017", borderRadius: '8px', height:'44px', color: "#fff"}} 
            className='btn filter-mission-block' onClick={() => setOpenAddModal(true)}>
            Nova permissão
          </button>
        </div>
      </div>

      <div
        style={{ margin: '0 !important' }}
        ref={tableRef}
        className='stock-adjustment-table new'
      >

        <div style={{boxShadow: (list.resultList ?? []).length < 1 && 'none'}} className='outer-table stock-transfer-outer-table'>
          <div className='flex'>
            {(list.resultList ?? []).length ? (
              <Table
                emptyFilter={emptyFilter}
                removeSelected={removeSelected}
                cdMissionList={cdMissionList}
                handleOrder={handleOrder}
                handleResize={handleResize}
                closeModal={(attr) => setOpenDeleteModal({show:true, selected:attr})}
                records={list.resultList}
                setCdMissionList={setCdMissionList}
                translate={translate}
              />
            ) : emptyFilter
            ? 
            <div style={{width: '100%', height: '500px', margin: '0px'}} className='relatory-no-data pictogram-empty'> 
              
              {isEqual(filters, DEFAULT_INITIAL_VALUES) ? <p>Sem dados</p> : <p>Não há cadastros no filtro selecionado</p>}
            </div> 
            :   (
              <div style={{width: '100%', height: '500px', margin: '0px'}} className='relatory-no-data pictogram-empty'> 
              
              <p>Sem resultado de busca</p>
              <p>Por favor, tente realizar uma nova busca.</p>
              </div>
            )}
          </div>
          {renderNewPagination()}
        </div>

      </div>

      {renderAlreadyMissionModal()}
      {renderAddModal()}
      {renderRemoveModal()}
      {renderErrorModal()}
      {renderSuccessModal()}
      {renderSuccessDeleteModal()}

    </div>
  )
}

StockTransferApprovers.propTypes = {
  auth: PropTypes.object.isRequired,
  count: PropTypes.number.isRequired,
  current: PropTypes.number.isRequired,
  logout: PropTypes.func.isRequired,
  menu: PropTypes.object.isRequired,
  missionBlockError: PropTypes.object,
  pages: PropTypes.number.isRequired,
  saveAttribute: PropTypes.func,
  fetchAttributes: PropTypes.func,
  translate: PropTypes.func.isRequired,
  attributeReducer:PropTypes.object,
  save:PropTypes.object,
  stockTransferApproversReducer: PropTypes.object,
  fetchStockTransferApprovers: PropTypes.func,
  list: PropTypes.object,
  edit: PropTypes.object,
  preserve: PropTypes.func,
  fetchMissions: PropTypes.func,
  options: PropTypes.object,
  change:PropTypes.object,
  updatePermissions: PropTypes.func,
  deleteAttributes:PropTypes.func,
  resetSave: PropTypes.func,
  deletePermissions: PropTypes.func,
  resetAll: PropTypes.func,
  updateAttribute: PropTypes.func,
  get: PropTypes.object
}

/* istanbul ignore next */
const mapStateToProps = (state) => ({
  ...state.paginateReducer,
  options: state.stockTransferApproversReducer.list.options,
  pages: state.paginateReducer.pages,
  edit: state.stockTransferApproversReducer.edit,
  list: state.stockTransferApproversReducer.missions.records,
  change: state.stockTransferApproversReducer.change,
  preserve: PropTypes.func,
});

/* istanbul ignore next */
const mapDispatchToProps = (dispatch) =>
  
  bindActionCreators(
    {...stockTransferApproversActions},
    dispatch
  )

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  translate(null, { wait: true, translateFuncName: 'translate' })(
    StockTransferApprovers
  )
)

export { StockTransferApprovers }
